import { useEffect, useState } from 'react';
import './ArqueoCaja.css'; // We will create this CSS

const DENOMINACIONES = [
    { valor: 200, tipo: 'billete' },
    { valor: 100, tipo: 'billete' },
    { valor: 50, tipo: 'billete' },
    { valor: 20, tipo: 'billete' },
    { valor: 10, tipo: 'billete' },
    { valor: 5, tipo: 'moneda' },
    { valor: 2, tipo: 'moneda' },
    { valor: 1, tipo: 'moneda' },
    { valor: 0.50, tipo: 'moneda' },
    { valor: 0.20, tipo: 'moneda' },
    { valor: 0.10, tipo: 'moneda' }
];

const ArqueoCaja = ({ onConfirm, onCancel, initialData }) => {
    const [conteo, setConteo] = useState({});
    const [totalCalculado, setTotalCalculado] = useState(0);

    useEffect(() => {
        calcularTotal();
    }, [conteo]);

    const handleCantidadChange = (valor, cantidad) => {
        setConteo(prev => ({
            ...prev,
            [valor]: parseInt(cantidad) || 0
        }));
    };

    const calcularTotal = () => {
        let total = 0;
        Object.entries(conteo).forEach(([valor, cantidad]) => {
            total += parseFloat(valor) * cantidad;
        });
        setTotalCalculado(total);
    };

    const handleSubmit = () => {
        console.log('🔵 ArqueoCaja: Cerrar Caja button clicked');
        console.log('🔵 ArqueoCaja: Total calculado:', totalCalculado);
        console.log('🔵 ArqueoCaja: Datos arqueo:', conteo);
        const data = {
            monto_final_real: totalCalculado,
            datos_arqueo: conteo
        };
        console.log('🔵 ArqueoCaja: Calling onConfirm with:', data);
        onConfirm(data);
    };

    return (
        <div className="arqueo-modal-overlay">
            <div className="arqueo-container">
                <h3>Arqueo de Caja (Conteo Ciego)</h3>
                <p className="arqueo-instruction">Por favor, ingrese la cantidad física de billetes y monedas.</p>

                <div className="denominaciones-grid">
                    {DENOMINACIONES.map(d => (
                        <div key={d.valor} className="denominacion-item">
                            <span className="label">S/ {d.valor.toFixed(2)}</span>
                            <input
                                type="number"
                                min="0"
                                placeholder="0"
                                className="conteo-input"
                                onChange={(e) => handleCantidadChange(d.valor, e.target.value)}
                            />
                            <span className="subtotal">
                                = S/ {((conteo[d.valor] || 0) * d.valor).toFixed(2)}
                            </span>
                        </div>
                    ))}
                </div>

                <div className="arqueo-footer">
                    <div className="total-display">
                        <span>Total Contado:</span>
                        <strong>S/ {totalCalculado.toFixed(2)}</strong>
                    </div>
                    <div className="actions">
                        <button className="btn-cancel" onClick={onCancel}>Cancelar</button>
                        <button className="btn-confirm" onClick={handleSubmit}>Cerrar Caja</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArqueoCaja;
